import React, { useEffect, useState } from "react"
import { getPostitCategoryString } from "../utils/PostitUtils"
import "./ConfirmDeleteCardModal.scss"
import { t } from "i18next"

interface IProps {
  card?: ICard
  show: boolean
  onConfirmDeletePostit: () => void
  onCancelDeletePostit: () => void
}

const ConfirmDeleteCardModal: React.FC<IProps> = ({ show, card, onConfirmDeletePostit, onCancelDeletePostit }) => {
  const [animate, setAnimate] = useState(false)

  useEffect(() => {
    if (show) {
      setAnimate(false)
      setTimeout(() => setAnimate(true), 10)
    } else {
      setAnimate(false)
    }
  }, [show])

  const confirmDeleteModal = (card?: ICard): React.ReactNode | Promise<React.ReactNode> => {
    return (
      <div
        className="modal fade show"
        tabIndex={-1}
        role="dialog"
        style={{
          display: "block",
          backgroundColor: "rgba(181, 127, 127, 0.95)",
        }}
      >
        <div
          className={`modal-dialog modal-dialog-centered ${animate ? "bouncy-modal" : ""}`}
          role="document"
          style={{
            filter: "drop-shadow(0 8px 32px rgba(0,0,0,0.35))",
            WebkitFilter: "drop-shadow(0 8px 32px rgba(0,0,0,0.35))",
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t("board.modals.confirmDeleteCard.title")}</h5>
            </div>
            <div className="modal-body">
              <p>{t("board.modals.confirmDeleteCard.body")}</p>
              <p>{getPostitCategoryString(card?.category)}</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => onCancelDeletePostit()}>
                {t("buttonActions.cancel")}
              </button>
              <button type="button" className="btn btn-danger" onClick={() => onConfirmDeletePostit()}>
                {t("buttonActions.delete")}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return show && confirmDeleteModal(card)
}

export default ConfirmDeleteCardModal
